import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import AuthShell from "@/components/app/AuthShell";
import { Loader2, ShieldAlert } from "lucide-react";
import { toast } from "sonner";

const valid = (p) => p.length >= 8 && /[A-Za-z]/.test(p) && /\d/.test(p);

export default function ChangePasswordRequired() {
  const { refresh, logout } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", new_password_confirm: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!valid(f.new_password)) return toast.error("La password deve contenere almeno 8 caratteri, con almeno una lettera e un numero");
    if (f.new_password !== f.new_password_confirm) return toast.error("Le due password non coincidono");
    if (f.new_password === f.current_password) return toast.error("La nuova password deve essere diversa da quella attuale");
    setBusy(true);
    try {
      await api.post("/auth/change-password", f);
      toast.success("Password aggiornata");
      await refresh();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <AuthShell title="Cambia la tua password" subtitle="Per motivi di sicurezza devi scegliere una nuova password prima di continuare.">
      <form onSubmit={submit} className="space-y-4" data-testid="force-pw-form">
        <div className="flex items-start gap-3 rounded-xl bg-amber-50 border border-amber-200 p-3 text-sm text-amber-800" data-testid="force-pw-notice">
          <ShieldAlert className="w-5 h-5 shrink-0" /> Minimo 8 caratteri, con almeno una lettera e un numero. Deve essere diversa da quella attuale.
        </div>
        <div><Label htmlFor="cur">Password attuale</Label><Input id="cur" type="password" value={f.current_password} onChange={set("current_password")} required data-testid="force-pw-current" /></div>
        <div><Label htmlFor="np">Nuova password</Label><Input id="np" type="password" value={f.new_password} onChange={set("new_password")} required data-testid="force-pw-new" /></div>
        <div><Label htmlFor="np2">Conferma nuova password</Label><Input id="np2" type="password" value={f.new_password_confirm} onChange={set("new_password_confirm")} required data-testid="force-pw-confirm" /></div>
        <Button type="submit" disabled={busy} className="w-full h-11 bg-[#0F2942] hover:bg-[#1B3B5F]" data-testid="force-pw-submit">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Salva nuova password"}
        </Button>
        <button type="button" onClick={logout} className="w-full text-sm text-slate-500 hover:text-slate-800" data-testid="force-pw-logout">Esci</button>
      </form>
    </AuthShell>
  );
}
